export const DEFAULT_PAGE_SIZE = 24
export const DEFAULT_SMALL_PAGE_SIZE = 8

export const GALLERY_SORTING_OPTIONS = {
  DEFAULT: 'newestFirst',
  OLDEST_FIRST: 'oldestFirst',
  TAKEN_AT_NEWEST: 'takenAtNewest',
  TAKEN_AT_OLDEST: 'takenAtOldest',
  MANUAL: 'manual',
  TAKEN_AT: 'takenAt', // legacy alias, decoded as takenAtNewest
}

export const MAX_COMMENT_LENGTH = 250

// iOS Safari kills and reloads the tab — no catchable error — when a page
// exceeds its memory budget, and the share-sheet download path buffers the
// whole file in the JS heap first. Files above this size only get the
// streaming browser download (which never touches page memory).
export const MAX_SHARE_SHEET_FILE_SIZE = 1000000000 // ~1GB
